"use client";

import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { useAuthStore } from "@chotca/auth";
import { getSdk } from "../sdk";
import { qk } from "../query-keys";

export function useMe(opts: { enabled?: boolean } = {}) {
  const setUser = useAuthStore((s) => s.setUser);
  const query = useQuery({
    queryKey: qk.me,
    queryFn: async () => getSdk().users.me(),
    enabled: opts.enabled !== false,
    staleTime: 5 * 60_000,
    gcTime: 30 * 60_000,
    retry: false,
  });
  React.useEffect(() => {
    if (query.data) setUser(query.data);
  }, [query.data, setUser]);
  return query;
}
